enum ServiceStatuses {
  ACTION_REQUIRED = "Action Required",
  PENDING = "Pending",
  CLOSED = "Closed",
  PENDING_SCA = "Pending SCA"
}

export default ServiceStatuses;
